/* eslint-disable react/no-array-index-key */
import { graphql } from "gatsby";
import React from "react";

import { Layout, LayoutColumn } from "../components/Layout";
import TitleAndMeta from "../components/TitleAndMeta";

import Author from "./components/Author";
import Feed from "./components/Feed";
import Pagination from "./components/Pagination";

function FeedPage({
  data,
  pageContext: { activatePagination, currentPageNum, totalPagesNum },
}) {
  const {
    allStrapiArticle: { edges },
  } = data;

  return (
    <Layout>
      <LayoutColumn Component="section" isMajor>
        <Feed edges={edges} />
        {activatePagination && (
          <Pagination
            currentPageNum={currentPageNum}
            totalPagesNum={totalPagesNum}
          />
        )}
      </LayoutColumn>
      <LayoutColumn Component="aside" isMajor={false}>
        <Author isPrimary />
      </LayoutColumn>
    </Layout>
  );
}

export const query = graphql`
  query TemplateHomeFeed($postsLimit: Int!, $postsOffset: Int!) {
    allStrapiArticle(
      limit: $postsLimit
      skip: $postsOffset
      sort: { order: DESC, fields: [createdAt] }
    ) {
      edges {
        node {
          slug
          title
          description
          createdAt
          updatedAt
          publish_at
          ...StrapiArticleCover
        }
      }
    }
  }
`;

export default FeedPage;

export function Head({ data, pageContext: { slug, currentPageNum } }) {
  const {
    allStrapiArticle: { edges },
  } = data;

  const { createdAt } = edges[0].node;
  const { updatedAt } = edges[edges.length - 1].node;

  return (
    <TitleAndMeta
      slug={currentPageNum === 0 ? null : slug}
      title={currentPageNum === 0 ? null : `الصفحة ${currentPageNum + 1}`}
      createdAt={createdAt}
      updatedAt={updatedAt}
      articleAuthor={{}}
    />
  );
}
